import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminRoute from '../components/AdminRoute';

// Lazy‑load pages
const HomePage = lazy(() => import('../pages/home/page'));
const LoginAlunoPage = lazy(() => import('../pages/login-aluno/page'));
const LoginAdminPage = lazy(() => import('../pages/login-admin/page'));
const RegisterPage = lazy(() => import('../pages/register/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const CoursePage = lazy(() => import('../pages/course/page'));
const LessonPage = lazy(() => import('../pages/lesson/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminCursosPage = lazy(() => import('../pages/admin/cursos/page'));
const AdminCourseDetailsPage = lazy(() => import('../pages/admin/cursos/detalhes/page'));
const AdminAlunosPage = lazy(() => import('../pages/admin/alunos/page'));
const AdminTurmasPage = lazy(() => import('../pages/admin/turmas/page'));
const AdminMatriculasPage = lazy(() => import('../pages/admin/matriculas/page'));
const AdminConfiguracoesPage = lazy(() => import('../pages/admin/configuracoes/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ObrigadoPage = lazy(() => import('../pages/obrigado/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/obrigado',
    element: <ObrigadoPage />,
  },
  {
    path: '/login-aluno',
    element: <LoginAlunoPage />,
  },
  {
    path: '/login-admin',
    element: <LoginAdminPage />,
  },
  {
    path: '/login',
    element: <Navigate to="/login-aluno" replace />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/course/:id',
    element: (
      <ProtectedRoute>
        <CoursePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/lesson/:courseId/:lessonId',
    element: (
      <ProtectedRoute>
        <LessonPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <AdminRoute>
        <AdminPage />
      </AdminRoute>
    ),
  },
  {
    path: '/admin/alunos',
    element: (
      <AdminRoute>
        <AdminAlunosPage />
      </AdminRoute>
    ),
  },
  {
    path: '/admin/cursos',
    element: (
      <AdminRoute>
        <AdminCursosPage />
      </AdminRoute>
    ),
  },
  {
    path: '/admin/cursos/:id',
    element: (
      <AdminRoute>
        <AdminCourseDetailsPage />
      </AdminRoute>
    ),
  },
  {
    path: '/admin/turmas',
    element: (
      <AdminRoute>
        <AdminTurmasPage />
      </AdminRoute>
    ),
  },
  {
    path: '/admin/matriculas',
    element: (
      <AdminRoute>
        <AdminMatriculasPage />
      </AdminRoute>
    ),
  },
  {
    path: '/admin/configuracoes',
    element: (
      <AdminRoute>
        <AdminConfiguracoesPage />
      </AdminRoute>
    ),
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default routes;
